<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        等级数据筛选
      </div>
      <div class="card-content">
        <a-form ref="searchForm" :form="form">
          <a-row>
            <a-col :span="5">
              <a-form-item label="用户名" v-bind="formItemLayout">
                <a-input
                  v-decorator="[
                    'name',
                  ]" allow-clear placeholder="请输入"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="昵称" v-bind="formItemLayout">
                <a-input
                  v-decorator="[
                    'Nickname',
                  ]" allow-clear placeholder="请输入"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="运营等级" v-bind="formItemLayout">
                <a-select
                  v-decorator="[
                    'rank',
                    {initialValue: ''}
                  ]"
                  allow-clear
                  placeholder="请选择"
                >
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="3">
                    金牌运营
                  </a-select-option>
                  <a-select-option value="2">
                    高级运营
                  </a-select-option>
                  <a-select-option value="1">
                    初级运营
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4" align="right">
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container">
      <div class="card-title">
        <div class="title-desc">
          <span>运营人员排名列表</span>
        </div>
      </div>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="dataList"
          :loading="loading"
          :pagination="pagination"
          :row-key="record => record.index"
          @change="handleTableChange"
        >
          <template slot="level" slot-scope="record">
            <span v-if="record === 1">
              初级运营
            </span>
            <span v-if="record === 2">
              高级运营
            </span>
            <span v-if="record === 3">
              金牌运营
            </span>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUserLvRanking
} from '@/api/system'
export default {
  data () {
    return {
      name: '',
      Nickname: '',
      rank: '0',
      form: this.$form.createForm(this, {}),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      dataList: [],
      columns: [
        {
          title: '排名',
          dataIndex: 'index'
        },
        {
          title: '用户名',
          dataIndex: 'userName'
        },
        {
          title: '昵称',
          dataIndex: 'nickName'
        },
        {
          title: '运营等级',
          dataIndex: 'level',
          scopedSlots: { customRender: 'level' }
        },
        {
          title: '运营评分',
          dataIndex: 'device'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      loading: false
    }
  },
  mounted () {
    this.getUserLvRanking()
  },
  methods: {
    toSearch () {
      this.pagination.current = 1

      this.getUserLvRanking()
    },
    resetForm () {
      this.form.resetFields()
      this.getUserLvRanking()
    },
    getUserLvRanking () {
      const pamr = {
        level: this.form.getFieldValue('rank') || '',
        nickName: this.form.getFieldValue('Nickname') || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        userName: this.form.getFieldValue('name') || ''
      }
      this.loading = true
      getUserLvRanking(pamr).then(res => {
        this.loading = false
        const reslist = res.result.list
        reslist.forEach((ele, index) => {
          ele['index'] = index + 1
        })
        this.dataList = reslist
        this.pagination.total = res.result.totalCount
      })
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getUserLvRanking()
    }
  }
}
</script>

<style lang="stylus" scoped>
.card-container
  .card-title
    .title-desc
      display flex
      align-items center
      span:nth-child(2)
        margin-left auto
.tag
  display flex
  flex-direction row
  align-items center
  .flag
    width 10px
    height 10px
    border-radius 50%
    margin-right 5px
    &.green
      background-color #57C22D
    &.gray
      background-color #8F96B3
</style>
